import { Divider, Grid } from "@mui/material";
import T from "utils/constants/T";
import {
  StyledBodyTypography,
  StyledTitleTypography,
} from "../../../CompanyDetailsScreen/CompanyDetails/CompanyTab/CompanyInfo";
import CashDCard from "components/common/CashDCard";
import { useSelector } from "store";
const ViewCompanyDetails = () => {
  const getUserDataByUSerID = useSelector((state) => state.getEmployeeData);
  const { countryName } = useSelector((state: any) => state.companyTabData);

  return (
    <Grid item xs={12}>
      <CashDCard borderRadius="20px">
        <Grid container rowSpacing={2}>
          <Grid item xs={6}>
            <StyledBodyTypography>{T.COMPANY_NAME}</StyledBodyTypography>
            <StyledTitleTypography>
              {getUserDataByUSerID.companyName}
            </StyledTitleTypography>
          </Grid>
          <Grid item xs={6}>
             {countryName === "New Zealand" ? (
              <StyledTitleTypography>{T.IRD}</StyledTitleTypography>
            ) : (
              <StyledTitleTypography>{T.ABN}</StyledTitleTypography>
            )}
            <StyledTitleTypography>{getUserDataByUSerID.ABN}</StyledTitleTypography>
          </Grid>
          <Grid className="divider" item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={6}>
            <StyledBodyTypography>{T.ADDRESS}</StyledBodyTypography>
            <StyledTitleTypography>
              {getUserDataByUSerID.address}
            </StyledTitleTypography>
          </Grid>
        </Grid>
      </CashDCard>
    </Grid>
  );
};

export default ViewCompanyDetails;
